import GetStartedStep from "../../../../steps/GetStartedStep.vue";
import PaymentPlanStep from "./PaymentPlanStep.vue";
import PaymentStep from "./payment-step/PaymentStep.vue";
import TransactionDetailsStep from "./TransactionDetailsStep.vue";

export default {
  PaymentStep,
  GetStartedStep,
  TransactionDetailsStep,
  PaymentPlanStep,
};
